module.exports = __webpack_public_path__ + "static/media/canon-camera.1d0e6cb0.jpg";